namespace SolovisGateway.Admin.Authentication {

    export class ExternalAuthAppDetailsControl extends Solovis.UI.BaseControl {

        private _externalAuthApp: ExternalAuthAppModel;
        private _allOrganizations: Array<ExternalAuthAppOrganizationModel>;
        private _externalAuthAppOrganizations: Array<ExternalAuthAppOrganizationModel>;
        private _initError;

        private _externalAuthAppCode: string;

        private _dataGrid: DevExpress.ui.dxDataGrid;

        constructor(options, externalAuthAppCode: string) {
            super(options);
            this._externalAuthAppCode = externalAuthAppCode;
            this._allOrganizations = new Array<ExternalAuthAppOrganizationModel>();
            this._externalAuthAppOrganizations = new Array<ExternalAuthAppOrganizationModel>();
        }

        public async doInitAsync() {
            let self = this;

            let promises = new Array<Promise<any>>();

            promises.push(Solovis.Rpc.invoke(
                "~/Admin/OrganizationAdmin/GetOrganizations",
                {},
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.organizations) {

                        response.result.organizations.forEach(organization => {
                            let model = new ExternalAuthAppOrganizationModel(organization);
                            self._allOrganizations.push(model);
                        });
                    }
                    else {
                        console.log("ERROR: ExternalAuthAppDetailsControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }
                })); 

            promises.push(Solovis.Rpc.invoke(
                "~/Rpc/AuthIntegration/GetExternalAuthApp",
                { externalAuthAppCode: self._externalAuthAppCode},
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.externalAuthApp) {

                        self._externalAuthApp = new ExternalAuthAppModel(response.result.externalAuthApp);
                    }
                    else {
                        console.log("ERROR: ExternalAuthAppDetailsControl.doInitAsync");
                        console.log(response.error);
                        self._initError = response.error;
                    }
                }));

            promises.push(Solovis.Rpc.invoke(
                "~/Rpc/AuthIntegration/GetExternalAuthAppOrgs",
                { externalAuthAppCode: self._externalAuthAppCode },
                function (response, success) {
                    if (success
                        && response
                        && response.result
                        && response.result.orgs) {

                        response.result.orgs.forEach(org => {
                            let model = new ExternalAuthAppOrganizationModel(org);
                            self._externalAuthAppOrganizations.push(model);
                        });
                    }
                    else {
                        console.log("ERROR: ExternalAuthAppDetailsControl.doInitAsync");
                        console.log(response.error);
                    }
                }));

            return Promise.all(promises);
        }

        public doRender() {            
            let headerDiv = $("<div>").appendTo(this.container);
            let header = $("<h2>").text(this._externalAuthApp.name).appendTo(headerDiv);
            
            this._renderOrganizationsGrid();
        }

        private _renderOrganizationsGrid() {
            let self: ExternalAuthAppDetailsControl = this;

            let detailStore = new DevExpress.data.ArrayStore({
                key: 'id',
                data: self._externalAuthAppOrganizations
            });

            let organizationsStore = new DevExpress.data.ArrayStore({
                key: 'id',
                data: self._allOrganizations
            });

            let dataGridContainer = $("<div>").appendTo(this.container);

            dataGridContainer = $("<div>")
                .dxDataGrid({
                    dataSource: {
                        store: detailStore,
                        sort: 'name'
                    },

                    allowColumnResizing: true,
                    allowColumnReordering: true,
                    rowAlternationEnabled: true,
                    searchPanel: { visible: true },
                    columnChooser: { enabled: false },
                    editing: {
                        mode: "form",
                        allowDeleting: true,
                        allowAdding: true
                    },

                    onRowRemoving: self._onRowRemovingHandler.bind(self),
                    onRowInserting: self._onRowInsertingHandler.bind(self),
                    onEditorPreparing: (e) => {
                        if (e.dataField == "name") {
                            e.editorName = "dxSelectBox";
                            e.editorOptions.dataSource = {
                                store: organizationsStore
                            };
                            e.editorOptions.displayExpr = "name"
                            e.editorOptions.searchEnabled = true;
                        }
                    },

                    onToolbarPreparing: function (e) {
                        let dataGrid = e.component;

                        e.toolbarOptions.items.unshift({
                            location: "before",
                            template: function () {
                                return $("<div/>")
                                    .addClass("informer")
                                    .append(
                                        $("<div>")
                                            .css("padding-left", "7px")
                                            .html(`<b>Organizations</b>`)
                                    );
                            }
                        });
                    },

                    width: "100%",

                    columns: [
                        {
                            dataField: 'name',
                            dataType: 'string',
                            caption: 'Name',
                            allowSorting: true
                        },
                        {
                            dataField: 'code',
                            dataType: 'string',
                            caption: 'Code',
                            allowSorting: true,
                            formItem: {
                                visible: false
                            }
                        }
                    ]
                })
                .appendTo(self.container);

            self._dataGrid = dataGridContainer.dxDataGrid("instance");
        }

        private _onRowRemovingHandler(e: any) {
            let deferred = $.Deferred();
            if (e.data) {
                let data = <ExternalAuthAppOrganizationModel>e.data;
                Solovis.Rpc.invoke(
                    "~/Rpc/AuthIntegration/DeleteExternalAuthAppOrg",
                    data.toDeleteParams(this._externalAuthApp.code),
                    function (response, success) {
                        if (success) {
                            deferred.resolve();
                        }
                        else {
                            console.log('ERROR: ExternalAuthAppDetailsControl._onRowRemovingHandler');
                            console.log(response.error);
                            deferred.reject(response.error.message);
                        }
                    });
            }

            e.cancel = deferred;
        }

        private _onRowInsertingHandler(e: any) {
            let deferred = $.Deferred();

            if (e.data && e.data.name) {
                let data = new ExternalAuthAppOrganizationModel(e.data.name);
                Solovis.Rpc.invoke(
                    "~/Rpc/AuthIntegration/AddExternalAuthAppOrg",
                    data.toAddParams(this._externalAuthApp.code),
                    function (response, success) {
                        if (success) {
                            e.data = data;
                            deferred.resolve();
                        }
                        else {
                            console.log('ERROR: ExternalAuthAppDetailsControl._onRowInsertingHandler');
                            console.log(response.error);
                            deferred.reject(response.error.message);
                        }
                    });
            }

            e.cancel = deferred;
        }
    }
}